import react, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import MusicPlayer from "../MusicPlayer";
import { useSelector } from "react-redux";
import { getUserAudioScript } from "../../../../thunks/editor/scriptThunks";
import { useDispatch } from "react-redux";
import Loader from "../../Loader";
import {
  setUserVoice,
  updateSlideScript,
  updateSlideVoiceFile,
} from "../../../../store/slides/slidesSlice";
import { closePopover } from "../../../../store/common/uiSlice";
import MusicMenu from "../../../music/MusicMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";

const AudioScript = () => {
  const dispatch = useDispatch();
  const getAudioList = useSelector((state) => state.script.userAudioScript);
  const { slides, currentSlideIndex } = useSelector((state) => state.slides);
  const currentSlide = useMemo(() => {
    return slides[currentSlideIndex];
  }, [slides, currentSlideIndex]);
  const [openMusicMenuIndex, setOpenMusicMenuIndex] = useState();
  const handleSlideMenu = (index) => {
    return setOpenMusicMenuIndex((prev) =>
      index !== undefined ? (prev === index ? undefined : index) : undefined
    );
  };

  const { voiceFile } = useMemo(() => {
    return { voiceFile: currentSlide?.voiceFile?.mp3 };
  }, [currentSlide]);

  const appState = useSelector((state) => state.appState);

  // let mediaRecorder;
  // let recordedChunks = [];
  useEffect(() => {
    dispatch(getUserAudioScript());
  }, []);
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const maxRecordingTime = 60 * 1000;
  const [remainingTime, setRemainingTime] = useState(maxRecordingTime / 1000);
  const countdownInterval = 1000;
  let mediaRecorderRef = useRef(null);
  let countdownRef = useRef(null);

  const startRecording = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const microphonePresent = devices.some(
        (device) => device.kind === "audioinput"
      );

      if (!microphonePresent) {
        alert("Microphone not found. Please connect a microphone device.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      const audioChunks = [];
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: "audio/mp3" });
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudioUrl(audioUrl);
      };

      mediaRecorder.start();
      setRecording(true);
      setRemainingTime(maxRecordingTime / 1000);

      countdownRef.current = setInterval(() => {
        setRemainingTime((prevTime) => Math.max(prevTime - 1, 0));
      }, countdownInterval);

      setTimeout(() => {
        handleRecordingTimeout();
      }, maxRecordingTime);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRecordingTimeout = () => {
    if (recording) {
      stopRecording();
      alert(
        `Recording time limit exceeded (60 seconds) please stop your recording`
      );
    }
  };

  useEffect(() => {
    if (remainingTime <= 0) {
      handleRecordingTimeout();
    }
  }, [remainingTime]);

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current = null;
      setRecording(false);
      clearInterval(countdownRef.current);
      countdownRef.current = null;
      setRemainingTime(maxRecordingTime / 1000);
    }
  };

  const audioClick = (audio) => {
    dispatch(setUserVoice(true));
    dispatch(updateSlideScript(""));

    dispatch(updateSlideVoiceFile({ mp3: audio.audio }));
    dispatch(closePopover());
  };
  return (
    <>
      {" "}
      {!recording ? (
        <button onClick={startRecording}>Add Recording</button>
      ) : (
        <button onClick={stopRecording}>Stop Recording</button>
      )}
      {audioUrl && (
        <a
          href={audioUrl}
          download="recorded_audio.mp3"
          style={{
            backgroundColor: "rgba(111, 27, 251, 0.5)",
            width: "236px",
            margin: "10px",
            borderRadius: "5px",
            border: "rgba(111, 27, 251, 0.5)",
            cursor: "pointer",
            gap: "11px",
            fontFamily: "Maven Pro",
            fontWeight: "600",
            fontSize: "18px",
            color: "#EDEDED",
            padding: "6px",
            display: "flex",
            height: "auto",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Download Audio
        </a>
      )}
      {appState === "loading" && (
        <div className="flex flex-grow h-4/5 justify-center text-sm text-gray-500 items-center text-center w-full">
          <Loader />
        </div>
      )}
      {getAudioList.length === 0 ? (
        <div className="flex flex-grow h-4/5 justify-center text-sm text-gray-500 items-center text-center w-full">
          {" "}
          No Audio to show.{" "}
        </div>
      ) : (
        <div className="grid grid-cols-5 gap-4 w-full h-full overflow-y-scroll pt-4">
          {" "}
          {(getAudioList || []).map((item, index) => (
            <div
              key={`user-audio-` + item.id}
              className="relative"
              onClick={(e) => {
                e.preventDefault();
                return audioClick({ ...item });
              }}
            >
              <>
                <FontAwesomeIcon
                  icon={faEllipsisH}
                  className="cursor-pointer bg-slides-label rounded-sm w-6 h-4  absolute top-2 right-2 text-white p-1 z-50"
                  onClick={(e) => {
                    e.stopPropagation();
                    return handleSlideMenu(index);
                  }}
                />
                {openMusicMenuIndex === index && (
                  <div
                    className="z-50"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSlideMenu();
                    }}
                  >
                    <MusicMenu
                      handleClose={handleSlideMenu}
                      id={item.id}
                      slideIndex={index}
                      className="left-[50%] bottom-[50%] w-[188px] h-auto shadow"
                      isAudio
                    />
                  </div>
                )}
              </>

              <MusicPlayer
                name={item.name}
                index={index}
                file={item.audio}
                isActive={voiceFile === item.audio}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default AudioScript;
